var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/array.js
// module id = 1gik
// module chunks = 0